// extracted by mini-css-extract-plugin
module.exports = {"box":"box___YvCQy","search_bg":"search_bg___3HsRn","search_input":"search_input___dTiJQ","searchBtn":"searchBtn___30r-C"};